import React from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setModal } from "../../features/modal/ModalSlice";
import apiClient from "../../services/apiClient";

const Signup = ({ onSubmit }) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm();

  const password = watch("password");
  const dispatch = useDispatch();
  // const [email, setEmail] = useState("");
  const handleLoginPopUp = () => {
    dispatch(setModal({ type: "LOGIN" }));
  };

  const onFormSubmit = async (data) => {
    try {
      // Sending data to the backend
      await apiClient.post("/register", data);

      // Handle response if needed (e.g., show success message, redirect, etc.)
      console.log("Registration successful");

      // Call onSubmit prop to switch to OTP screen
      onSubmit({ email: data?.email_id });
    } catch (error) {
      console.error("Error:", error);
      setError("email_id", { type: "manual", message: error?.response?.data?.message });
      // Handle error (e.g., show error message)
    }
  };

  return (
    <div>
      <h2>Sign Up</h2>
      <Form onSubmit={handleSubmit(onFormSubmit)} className="mt-4">
        <Form.Group controlId="formUsername" className="my-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Name"
            {...register("name", {
              required: "Name is required",
              minLength: { value: 3, message: "Name must be at least 3 characters" },
            })}
          />
          {errors.name && <Form.Text className="text-danger">{errors.name.message}</Form.Text>}
        </Form.Group>

        <Form.Group controlId="formEmail" className="my-3">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            // onChange={(e) => setEmail(e.target.value)}
            {...register("email_id", {
              required: "Email is required",
              pattern: { value: /^\S+@\S+$/i, message: "Invalid email address" },
            })}
          />
          {errors.email_id && (
            <Form.Text className="text-danger">{errors.email_id.message}</Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="formPassword" className="my-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            {...register("password", {
              required: "Password is required",
              minLength: { value: 6, message: "Password must be at least 6 characters" },
            })}
          />
          {errors.password && (
            <Form.Text className="text-danger">{errors.password.message}</Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="formConfirmPassword">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Re-enter password"
            {...register("confirm_password", {
              required: "Confirm Password is required",
              validate: (value) => value === password || "Passwords do not match",
            })}
          />
          {errors.confirm_password && (
            <Form.Text className="text-danger">{errors.confirm_password.message}</Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="formPhoneNo" className="my-3">
          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Phone Number"
            {...register("phone_number")}
          />
        </Form.Group>

        <button className="btn btn-primary custom-btn-full my-3" type="submit">
          Submit
        </button>
        <Form.Text className="text-center">
          Already have an account <Link onClick={handleLoginPopUp}>Login</Link>
        </Form.Text>
      </Form>
    </div>
  );
};

export default Signup;
